module.exports = "/_next/static/images/415e6918c45927248ff331c3a0880544-get-earnings.png";